import { useIntl } from 'react-intl';
import { Outlet } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout';
import Tab from 'src/components/navigation/Tab';
import TabRow from 'src/components/navigation/TabRow';
import { PERMISSION } from 'src/features/auth';
import { userManagementMessages } from 'src/features/userManagement/utils/messages';
import useHasPermissions from 'src/hooks/useHasPermissions';

const UserManagementLayout = () => {
    const { formatMessage } = useIntl();
    const permissionInvitation = useHasPermissions([PERMISSION.USERS_INVITATION]);
    return (
        <MainLayout>
            <TabRow>
                <Tab to="/user-management" end>
                    {formatMessage(userManagementMessages.users)}
                </Tab>
                <Tab to="/user-management/deactivated" end>
                    {formatMessage(userManagementMessages.deactivated)}
                </Tab>
                <Tab to="/user-management/clients" end>
                    {formatMessage(userManagementMessages.clients)}
                </Tab>
                {permissionInvitation && (
                    <Tab to="/user-management/invitations">{formatMessage(userManagementMessages.invitations)}</Tab>
                )}
            </TabRow>
            <Outlet />
        </MainLayout>
    );
};

export { UserManagementLayout };
